import React from 'react'
import './scss/AgentCard.scss'
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import PhoneIcon from '@material-ui/icons/Phone';
import FacebookIcon from '@material-ui/icons/Facebook';
import TwitterIcon from '@material-ui/icons/Twitter';
import InstagramIcon from '@material-ui/icons/Instagram';
import LinkedInIcon from '@material-ui/icons/LinkedIn';

const AgentCard = () =>{
    return(
        <div className="card agent-card">
            <a href="/Agent"><img src="/images/agent1.jpg"  alt="agent"/></a>
            <div className="p-3">
                <h5>Adam Jarod</h5>
                <p>We went down the lane, by the body of the man in black, sodden now from the overnight hail, and broke into the woods at the foot of the hill.</p>
                <span>
                    <MailOutlineIcon />linxiao0106@gmail.com
                    <br/>
                    <PhoneIcon />(917) 680-2883
                </span> 
                <div className="agent-social mt-2">
                    <ul>
                        <li><FacebookIcon /></li>
                        <li><LinkedInIcon /></li>
                        <li><InstagramIcon /></li>
                        <li><TwitterIcon /></li>
                    </ul>
                    <a href="/Agent"><button className="btn btn-outline-danger">Full Profile</button></a>
                </div>
            </div>
        </div>
    )
}

export default AgentCard